// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import fileCheck02Icon from "@/assets/icons/file-check-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FileCheck02IconProps = Omit<IconProps, "name">;

export function FileCheck02Icon(props: FileCheck02IconProps): React.ReactNode {
  return <Icon name={fileCheck02Icon} {...props} />;
}
